export const initSkeletons = (ctx) => {
    ctx.getScene().skeletons.forEach(() => { });
};
